export enum Roles {
  ADMIN_ID = 4,
  MANAGER_ID = 3,
  DIRECTOR_ID = 5,
}
